import { render, staticRenderFns } from "./HistoryDetailInventoryQuotas.vue?vue&type=template&id=14c119db"
import script from "./HistoryDetailInventoryQuotas.vue?vue&type=script&lang=js"
export * from "./HistoryDetailInventoryQuotas.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetailInventoryQuotas.vue?vue&type=style&index=0&id=14c119db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports